export default __webpack_public_path__ + "static/media/entertainment_768.17d2740e.webp";